module.exports = __webpack_public_path__ + "img/グループ・メンバーの無料アイコン素材.ff17dc37.png";